{
  "page_forside_title": "Helsenorge – your health online",
  "fastlegepanel_title": "Your General Practitioner (GP)",
  "fastlegepanel_description": "Contact your GP and view all services",
  "sharing_Status_Delt_Med_Barnet": "Shared with child",
  "se_mer": "See more",
  "se_mindre": "See less",
  "tjenestepanelVisFlere": "See more services",
  "tjenestepanelVisFarre": "Show fewer services",
  "savnerDuTjenesterTitle": "Are you missing any services?",
  "savnerDuTjenesterDescription": "You have not consented to the following services:",
  "savnerDuTjenesterTimeavtaler": "Appointments and referrals",
  "savnerDuTjenesterPasientreiser": "Patient travel",
  "savnerDuTjenesterDialog": "Dialogue with health contacts",
  "savnerDuTjenesterButton": "Change consent",
  "savnerDuTjenesterFullmektigButton": "View consent",
  "inactivity_SignedOut_Button_GoToRoot": "Home",
  "inactivity_SignedOut_Button_SignInAgain": "Log in again",
  "inactivity_SignedOut_Title": "You were inactive for a while and have been logged out",
  "inactivity_LoginUrl": "/auth/signin",
  "signedOut_SignedOut_Title": "You are logged out",
  "signedOut_SignedOut_Explanation": "You are now logged out",
  "notificationPanelFullSamtykke": "You have given your consent for Basic or Basic+. As a result, you only have access to some of the services on Helsenorge. If you would like to have access to all the services, you will need to change your consent to Full access. If you are under the age of 16, your legal guardian will need to change the consent for you.",
  "notificationPanelInnsynssperre": {
    "type": "markdown",
    "value": "You have blocked your access to logged-in services on Helsenorge. To remove this block, you must submit a form to regain access.\n\n[Form for adults](https://www.helsenorge.no/48d643/globalassets/skjema/tilgangssperre/hn-sperre-gjenaapne-helsenorge.pdf)\n\n[Form for children under 16](https://www.helsenorge.no/48d667/globalassets/skjema/tilgangssperre/hn-sperre-gjenaapne-helsenorge-barn.pdf)"
  },
  "digitalt_inaktiv_beskrivelse": {
    "type": "markdown",
    "value": "You have opted not to use Helsenorge personally. The person to whom you have granted power of attorney will still be able to use the services and read messages about you.\n\nTo use Helsenorge again, you must complete and submit the form below: [Form to become active on Helsenorge again.](https://www.helsenorge.no/globalassets/skjema/inaktiv/hn-skjema-inaktiv-1.pdf)"
  },
  "digitalt_inaktiv_representasjon_tittel": "{navn} is inactive on Helsenorge",
  "digitalt_inaktiv_tittel": "You are inactive on Helsenorge",
  "digitalt_inaktiv_representasjon_beskrivelse": {
    "type": "markdown",
    "value": "{navn}, on behalf of whom you have power of attorney to use Helsenorge, has decided to stop using Helsenorge. This means that {navn} will not be able to use the services and will not receive notifications and messages on Helsenorge.\n\nTo use Helsenorge again, {navn} must submit the form below: [Form to become active on Helsenorge again](https://www.helsenorge.no/globalassets/skjema/inaktiv/hn-skjema-inaktiv-1.pdf) (in Norwegian only)."
  }
}
